module.exports = __webpack_public_path__ + "img/modal-success.9da5b768.svg";